import { AppContext, AppMode } from "../http/protocol";
import { EMAIL_QUERY_PARAM, PHONE_NUMBER_QUERY_PARAM, VERIFICATION_CHANNEL_PARAM } from "../ui/LoginForm";

export function getLoginPromptParams(email: string = "", phoneNumber: string = "", verificationChannel: string = "") {
  const params = new URLSearchParams();
  params.append(EMAIL_QUERY_PARAM, email);
  params.append(PHONE_NUMBER_QUERY_PARAM, phoneNumber);
  params.append(VERIFICATION_CHANNEL_PARAM, verificationChannel);
  return `?${params.toString()}`;
}

export type ContextClass = { particular: string; common: string };

export const getContextClass = (appContext?: AppContext, appMode?: AppMode): ContextClass => {
  let context = appContext?.toLowerCase();
  let mode = appMode?.toLowerCase() ?? AppMode.NONE.toLocaleLowerCase();
  return { particular: `context-${context}-mode-${mode}`, common: `context-${context}` };
};

export const isDevEnv = () => process.env.NODE_ENV === "development";

export const debounce = (func: (...args: any[]) => void, wait: number) => {
  let timeout: NodeJS.Timeout | null = null;
  return (...args: any[]) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
};
